import { useState } from 'react'
import './App.css';
import MintComponent from './MintComponent';
import NavBar from './NavBar';

function App() {
  const [accounts, setAccounts] = useState([])
  return (
    <div className="App commonContainer mx-lg-auto mx-5">
      <NavBar accounts={accounts} setAccounts={setAccounts} />
      <MintComponent accounts={accounts} setAccounts={setAccounts} />

      <div className="py-lg-5 d-lg-block d-none">
        <p>Verified Smart Contract Address :<br /></p>
        <p className='col-12 pt-3'>0x1ffa754c2BD705bF5853De96E06BAfF6de6137AD</p>
        <p>We are using ERC721A by Azuki.</p>

      </div>
      <hr className="greyline mb-5 mt-5" />
      <footer className='text-center'>
        <div className='copyright pb-4'>© 2022 Bored Goats</div>
      </footer>
    </div>
  );
}

export default App;
